import { render, staticRenderFns } from "./PurchaseBill.vue?vue&type=template&id=7aae706a&"
import script from "./PurchaseBill.vue?vue&type=script&lang=js&"
export * from "./PurchaseBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports